<template>
  <div>
    <div v-for="(userItem, index) in users" :key="index">
      <ProjectUserListItem
        @update="updateUserItem"
        :userItem="userItem"
        :index="index"
        :newOccupationList="newOccupationList"
        @addNew="addNewRow"
        :selectedIndex="selectedIndex"
        :isEditOccupation="isEditOccupation"
        @editOccupation="editOccupation"
        @updateOccupation="updateOccupationName"
        @deleteOccupation="deleteOccupation"
      />
    </div>
    <modal
      name="confirmDeleteDialog"
      classes="modalBoon"
      :clickToClose="true"
      transition="nice-modal-fade"
      :delay="100"
      :width="450"
    >
      <h2>{{ $t('Delete Occupation?') }}</h2>
      <p>{{ $t('Are you sure you want to delete the occupation') }}</p>
      <p>{{ $t('This action cannot be undone!') }}</p>
      <ul class="modalButtons">
        <li>
          <button class="darkButton" @click="confirmedDeleteOccupation()">{{ $t('Ta bort konto') }}</button>
        </li>
        <li>
          <button class="lightButton">{{ $t('Återställ lösenord') }}</button>
        </li>
      </ul>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProjectUserListItem from './ProjectUserListItem';
import { EventBus } from '@/common/eventbus';

export default {
  name: 'ProjectUserList',
  data() {
    return {
      selectedIndex: -1,
      isEditOccupation: false,
      // usersList: []
    };
  },
  props: {
    userList: {
      type: String,
      default: '',
    },
    project: {
      type: Object,
      default: () => {
        return {};
      },
    },
    users: {
      type: Array,
      default: () => {
        return [];
      },
    },
    newOccupationList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    ...mapActions([
      'addProjectUserItem',
      'updateProjectUserItem',
      'addProjectUserItemByIndex',
      'updateProjectUserItemOccupation',
      'deleteProjectUserItem',
    ]),
    addProjectUser: function () {
      this.addProjectUserItem({ project: this.project, userList: this.userList });
      // this.usersList.push({occupation: "", companyId: "", personId: ""});
    },
    updateUserItem: function ({ userItem, property, newValue }) {
      // console.log(property, newValue);
      this.updateProjectUserItem({ userItem, property, newValue, project: this.project });
    },
    /**
     * add new occupation in state
     * @param selectedIndex
     */
    addNewRow: function ({ selectedIndex }) {
      this.isEditOccupation = true;
      this.selectedIndex = selectedIndex;
      this.addProjectUserItemByIndex({ userList: this.userList, index: selectedIndex });
    },
    /**
     * selected occupation name to proejct update in DB
     * @param selectedIndex, occupation
     */
    updateOccupationName: function ({ selectedIndex, occupation }) {
      // console.log(selectedIndex, occupation);
      this.selectedIndex = selectedIndex;
      var matchOccupation = this.users.filter(
        (item) => item.occupation.toLowerCase().trim() === occupation.toLowerCase().trim()
      )[0];
      // console.log(matchOccupation);
      if (matchOccupation) {
        EventBus.$emit('showMessageToUser', {
          message: 'The selected occupation {occupation} already exists',
          occupation: occupation,
          type: 'error',
          duration: 5000,
        });
        return false;
      }
      EventBus.$emit('showMessageToUser', {
        message: 'New occupation {occupation} has been created',
        occupation: occupation,
        type: 'success',
        icon: 'done',
        duration: 5000,
      });
      setTimeout(() => {
        this.isEditOccupation = false;
      }, 5000);
      this.updateProjectUserItemOccupation({
        userList: this.userList,
        index: this.selectedIndex,
        occupation: occupation,
      });
    },
    /**
     * selected occupation edit
     */
    editOccupation: function () {
      this.isEditOccupation = !this.isEditOccupation;
    },
    /**
     * delete occupation from DB
     * @param selectedIndex
     */
    deleteOccupation: function ({ selectedIndex }) {
      // this.selectedIndex = selectedIndex;
      // this.$modal.show('confirmDeleteDialog');
      this.confirmedDeleteOccupation(selectedIndex);
    },
    confirmedDeleteOccupation: function (selectedIndex) {
      // console.log(this.selectedIndex);
      EventBus.$emit('showMessageToUser', {
        message: 'Occupation has been deleted',
        type: 'success',
        icon: 'done',
        duration: 3000,
      });
      this.deleteProjectUserItem({ userList: this.userList, index: selectedIndex });
      setTimeout(() => {
        this.selectedIndex = -1;
      }, 3000);
      this.$modal.hide('confirmDeleteDialog');
    },
  },
  computed: {
    ...mapGetters(['hasSimplePermissions']),
  },
  components: {
    // BLabelled,
    // Multiselect
    ProjectUserListItem,
  },
  mounted: async function () {
    // console.log(JSON.stringify(this.project[this.userList]));
  },
  watch: {
    $route: async function (to, from) {},
  },
};
</script>



// WEBPACK FOOTER //
// src/components/project/ProjectUserList.vue